<template>
    <div class="container container-publication">
        <h1 class="category-title">{{ publi.categoria.nombre }}</h1>
	    <h1 class="publication-title" >
	    	<router-link :to="{ name: 'dapubdet', params: { idpublicacion: publi.id }}">{{ publi.titulo }}</router-link>
	    </h1>
        <div class="publication-description" v-html="publi.descripcion"></div>
        <p class="publication-system">{{ publi.sistema.nombre }}</p>
        <template v-for="e in publi.etiquetas">
            <span class="publication-label-base">{{ e.nombre }}</span>
        </template>
        <div>
            <span class="publication-label-base publication-label-resources" v-if="publi.recursos.length > 1" variant="light">{{ publi.recursos.length }} recursos</span>
            <span class="publication-label-base publication-label-resources" v-else variant="light">{{ publi.recursos.length }} recurso</span>
        </div>
        
        <!--
        <ul class="publication-number-resources">
            <li v-for="r in publi.recursos">
                <template v-if="r.numero>1">{{ r.numero }} recursos</template>
                <template v-else>{{ r.numero }} recurso</template>
                <span :class="r.formato.extension">{{ r.formato.extension }}</span>
            </li>
        </ul>
        -->
    </div>
</template>

<script>
	export default {
        name: "Publication",
        props: [
            "publi"
        ]
    }
</script>

<style lang="scss" scoped>
    @import '../scss/components/publication';
</style>


// WEBPACK FOOTER //
// src/components/Publication.vue